const SampleCons = {
  FOOD_MATRIX: [
    { value: "AqueousSolution", label: "Aqueous Solution" },
    { value: "AppleJuice", label: "Apple Juice" },
    { value: "AppleSurface", label: "Apple Surface" },
    { value: "BulkQuinoa", label: "Bulk Quinoa" },
    { value: "InfantFormula", label: "Infant Formula" },
    { value: "MilkFormula", label: "Milk Formula" },
  ],

  ANALYTE: [
    { value: "R6G", label: "Rhodamine 6G" },
    { value: "MalachiteGreen", label: "Malachite Green" },
    { value: "Melamine", label: "Melamine" },
  ],
  EXTRACTION_SOLVENT: [
    { value: "Acetonitrile", label: "Acetonitrile" },
    { value: "Aqueous", label: "Aqueous" },
    { value: "Methanol", label: "Methanol" },
  ],
  ANALYTE_NAMES: [
    {
      modelName: "FUB-AMB",
      displayName: "AMB-FUBINACA (FUB-AMB)",
    },
    {
      modelName: "MDMA",
      displayName: "3-4 Methylenedioxymethamphetamine (MDMA)",
    },
    {
      modelName: "MSM",
      displayName: "Methylsulfonylmethane (MSM)",
    },
    {
      modelName: "MorphineTab",
      displayName: "Morphine Tablet",
    },
    {
      modelName: "PCP",
      displayName: "Phencyclidine (PCP)",
    },
    {
      modelName: "PEG",
      displayName: "Polyethylene Glycol (PEG)",
    },

    {
      modelName: "GHB",
      displayName: "Gamma-Hydroxybutyrate (GHB)",
    },
    {
      modelName: "BagBlue",
      displayName: "Plastic Bag",
    },
    {
      modelName: "BagPink",
      displayName: "Plastic Bag",
    },
    {
      modelName: "BagTransparent",
      displayName: "Plastic Bag",
    },
    {
      modelName: "BagYellow",
      displayName: "Plastic Bag",
    },
    {
      modelName: "BakingSoda",
      displayName: "Baking Soda",
    },

    {
      modelName: "LGlutamine",
      displayName: "L-Glutamine",
    },
    {
      modelName: "4ANPP",
      displayName: "4-ANPP",
    },
    {
      modelName: "BG",
      displayName: "Chip Background",
    },
    {
      modelName: "ABFubinica",
      displayName: "AB-Fubinaca",
    },
  ],
};

export default SampleCons;
